export default __webpack_public_path__ + "static/media/Treatment_SLEEK_LIGHT_200_S.47829331.png";